import { mobileBottomContainerFixed } from './styles.css'

export const MobileBottomContainerFixed: React.FC = ({ children }) => {
  return <div className={mobileBottomContainerFixed}>{children}</div>
}
